import { useIntl } from 'react-intl';
import { useCleanCopies } from '../useCleanCopies';
import { cleanCopiesMessages as messages } from './cleanCopiesMessages';

/**
 * "Clean copies 9 / 14": the text of the Work badge while a clean-copies run is `running` (design:
 * trial-upsell b5). Null with no run, after the run and when `enabled` is false (no request then).
 */
export function useCleanCopiesNavLabel(enabled: boolean): string | null {
  const intl = useIntl();
  const { cleanCopies } = useCleanCopies({ skip: !enabled });
  if (cleanCopies === null || cleanCopies.status !== 'running') {
    return null;
  }
  return intl.formatMessage(messages.navLabel, { done: cleanCopies.done, total: cleanCopies.total });
}
